export const iconFontAwesomeHandsHandHoldingDollar = (
	<i className="fa-solid fa-hand-holding-dollar"></i>
);
